module.exports = __webpack_public_path__ + "img/trophy.e3f8039c.png";